import { Injectable, EventEmitter } from '@angular/core';
import { Mensagem } from '../_classes/mensagem';
import { ToastrService } from 'ngx-toastr';
import { TipoMensagem } from '../_classes/enum/tipo_mensagem';

@Injectable({
  providedIn: 'root'
})
export class MensagemService {
  mensagens: Array<Mensagem>;
  private timeOutPadrao = 4000;
  emissorMensagem = new EventEmitter<Mensagem[]>();

  constructor(private toast: ToastrService) {}

  registrarMensagem(msg: Mensagem) {
    if (!this.mensagens) {
      this.mensagens = new Array<Mensagem>();
    }
    this.mensagens.push(msg);
    this.emissorMensagem.emit(this.mensagens);
    //console.log('mensagens existentes');
    //console.log(this.mensagens);
  }

  emitirMensagensExistentes() {
    this.emissorMensagem.emit(this.mensagens);
  }

  mostrarMsg(x: Array<Mensagem>) {
    if (x) {
      x.forEach(e => {
        if (e) {
          //console.log('existe mensagem');
          //console.log(e);
          switch (e.tipo) {
            case TipoMensagem.ERRO:
              this.mostrarErro(e);
              break;
            case TipoMensagem.INFORMACAO:
              this.mostrarInformacao(e);
              break;
            case TipoMensagem.SUCESSO:
              this.mostrarSucesso(e);
              break;
            case TipoMensagem.AVISO:
              this.mostrarAviso(e);
              break;
            default:
              //console.log('default');
              break;
          }
        }
      });
      //console.log('vou limpar as mensagens');
      this.mensagens = new Array<Mensagem>();
    }
  }

  private mostrarErro(msg: Mensagem) {
    //console.log('mostrarErro');
    setTimeout(() =>
      this.toast.error(msg.mensagem, msg.titulo ? msg.titulo : 'Mensagem', {
        timeOut: msg.timeout ? msg.timeout : this.timeOutPadrao
      })
    );
  }
  private mostrarInformacao(msg: Mensagem) {
    setTimeout(() =>
      this.toast.info(msg.mensagem, msg.titulo ? msg.titulo : 'Mensagem', {
        timeOut: msg.timeout ? msg.timeout : this.timeOutPadrao
      })
    );
  }
  private mostrarSucesso(msg: Mensagem) {
    setTimeout(() =>
      this.toast.success(msg.mensagem, msg.titulo ? msg.titulo : 'Mensagem', {
        timeOut: msg.timeout ? msg.timeout : this.timeOutPadrao
      })
    );
  }
  private mostrarAviso(msg: Mensagem) {
    setTimeout(() =>
      this.toast.warning(msg.mensagem, msg.titulo ? msg.titulo : 'Mensagem', {
        timeOut: msg.timeout ? msg.timeout : this.timeOutPadrao
      })
    );
  }
}
